// JavaScript code to handle adding/removing a class on scroll
const mainMenuSticky = function() {
    const body = document.body;
    const headerNavContainer = document.querySelector('.header-navs');
    let isStickyActive = false;

    const _activateSticky = function () {

        if (isStickyActive) {
            return;
        }

        isStickyActive = true;
        body.classList.add('short-main-menu');
        $('.header-navs').removeClass('extend');
        $('.autocomplete--result--div').hide().attr('aria-hidden', true);
        $('.mobile-store-selector .modal-store-selector').focus();
        headerNavContainer.style.width = headerNavContainer.children[0].offsetWidth + headerNavContainer.children[1].offsetWidth + 'px';
        manageEraseButton();
    };

    const _disabledSticky = function () {

        if (!isStickyActive) {
            return;
        }
        isStickyActive = false;
        body.classList.remove("short-main-menu");
        $('.header-navs').addClass('extend');
        headerNavContainer.removeAttribute('style');
    }

    return {
        activateSticky: _activateSticky,
        disabledSticky: _disabledSticky,
    };

}();

window.onload = function() {

    let lastScrollTop = 0;
    const headerNavContainer = document.querySelector('.header-navs');

    const toggleMenuScroll = function() {
        const currentScroll = window.scrollY || window.pageYOffset || 0;

        if (currentScroll > lastScrollTop + 20 && currentScroll > 200) {
            mainMenuSticky.activateSticky();
        } else if (currentScroll < lastScrollTop || currentScroll < 200) {
            mainMenuSticky.disabledSticky();
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    };

    if (headerNavContainer && !isInWebview()) {
        $(window).on('scroll', _.throttle(toggleMenuScroll, 100));

        if (window.scrollY > 200) {
            mainMenuSticky.activateSticky();
            lastScrollTop = window.scrollY;
        }
    }
};
